<template>
    <form @submit.prevent="$emit('submit')" class="step-form">
      <div class="form-group">
        <label>Comment préférez-vous être recontacté ?</label>
        <div class="radio-group">
          <label class="d-flex align-items-center">
            <input type="radio" value="E-mail" v-model="value.contactPreference" /> E-mail
          </label>
          <label>
            <input type="radio" value="Téléphone" v-model="value.contactPreference" /> Téléphone
          </label>
          <label>
            <input type="radio" value="Peu importe" v-model="value.contactPreference" /> Peu importe
          </label>
        </div>
      </div>
  
      <div class="form-group">
        <label for="phoneSlot">Créneau idéal pour un échange téléphonique ?</label>
        <input type="text" id="phoneSlot" v-model="value.phoneSlot" />
      </div>
  
      <div class="button-group">
        <!-- <button type="button" @click="$emit('prev')">Précédent</button> -->
        <button type="submit" class="submit-button">ENVOYER LA DEMANDE</button>
      </div>
  
      <p class="small-text">Aucun engagement - Demande gratuite</p>
    </form>
  </template>
  
  <script>
  export default {
    name: 'StepThree',
    props: {
      value: {
        type: Object,
        required: true
      }
    },
    mounted() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
  </script>
  
  <style scoped>
  .step-form {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
  }
  .form-group label {
    font-weight: 500;
    display: block;
    margin-bottom: 0.25rem;
  }
  input[type="text"] {
    width: 100%;
    padding: 0.6rem;
    border: 1px solid #345b48;
  }
  .radio-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 1.5rem;
    margin-left: 2rem;
  }
  .button-group {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
  }
  button {
    padding: 0.75rem 1.5rem;
    background-color: #345b48;
    color: white;
    border: none;
    cursor: pointer;
  }
  .submit-button {
    background-color: #345b48;
  }
  .small-text {
    font-size: 0.875rem;
    color: #666;
    text-align: center;
  }
  input[type='radio']:after{
    border-radius: 0px;
    top: -3px;
    left: -3px;
    border: 1px solid #345b48;
  }

input[type='radio'] {
  appearance: none;
  -webkit-appearance: none;
  width: 1.1rem;
  height: 1.1rem;
  border: 2px solid #345b48;
  border-radius: 0;
  cursor: pointer;
  position: relative;
  margin-right: 0.5rem;
}

input[type='radio']:checked {
  background-color: #345b48;
}

input[type='radio']:focus {
  outline: 2px solid #345b48;
}
.form-group input:focus {
    border: 2px solid #4a6c5e; 
    outline: none;
  }
  </style>